import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateServicoProdutoColumnDefinition 
 */

type Props = {
  status: number;
  onActionEditar: (idRequisicaoProdutoServico: number | null, openState: boolean) => void;
  onActionDeletar: (idRequisicaoProdutoServico: number | null, openState: boolean) => void;
};

export const GenerateServicoProdutoColumnDefinition = ({
  status,
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  const computeTipoTitle = (statusx: number) => {
    switch (statusx) {
      case 1:
        return "Produto";
      case 0:
        return "Serviço";
      default:
        return "?";
    }
  };

  const computeTipoColor = (statusx: number) => {
    switch (statusx) {
      case 1:
        return "green";
      case 0:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeTipoDescription = (statusx: number) => {
    switch (statusx) {
      case 1:
        return "Produto";
      case 0:
        return "Serviço";
      default:
        return "?";
    }
  };

  return [
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      minWidth: 80,
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeTipoTitle(params.value === 'P' ? 1 : 0)}
            color={computeTipoColor(params.value === 'P' ? 1 : 0)}
            description={computeTipoDescription(params.value === 'P' ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "numero",
      filterable: false,
      headerName: "Nº",
      minWidth: 70,
      width: 70,
      sortable: false,
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Produto/Serviço",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: "unidade",
      filterable: false,
      headerName: "Unidade",
      minWidth: 100,
      width: 100,
      sortable: false,
    },
    {
      field: "quantidade",
      filterable: false,
      headerName: "Quantidade",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div>
            {
              value !== null && value !== undefined
                ? new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
                : ''
            }
          </div>
        );
      }
    },
    {
      field: "subconta",
      filterable: false,
      headerName: "Sub-conta",
      minWidth: 200,
      width: 200,
      sortable: false,
    },
    {
      field: 'idRequisicaoProdutoServico',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              disabled={status === 1 || status === 2 || status === 3 || status === 5}
              onMouseDown={e => {
                if (status === 1 || status === 2 || status === 3 || status === 5) return;
                onActionEditar(params.value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className={status === 1 || status === 2 || status === 3 || status === 5 ? "text-gray-200" : "dark:text-white text-primary-green"} />
            </IconButton>

            <IconButton
              disabled={status === 1 || status === 2 || status === 3 || status === 5}
              onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className={status === 1 || status === 2 || status === 3 || status === 5 ? "text-gray-200" : "text-red-500"} />
            </IconButton>
          </div>
        );
      }
    },
  ];
}